import StepBox from './StepBox.view';
export default StepBox;
